var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"style":{"fill":"#ffffff"},"points":"495,227.5 267.5,227.5 267.5,0 227.5,0 227.5,227.5 0,227.5 0,267.5 227.5,267.5 227.5,495 \n\t267.5,495 267.5,267.5 495,267.5 "}));
}

PlusInline.defaultProps = {"height":"24px","width":"24px","version":"1.1","viewBox":"0 0 495 495","xmlSpace":"preserve"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
